"use client";
import React, { useState } from "react";
import Screen from "../../components/Screen";
import ProfileHeaderSection from "../../components/ProfileHeaderSection";
import HeaderDescription from "../../components/HeaderDescription";
import AppForm from "../../components/forms/AppForm";
import { AppField } from "../../components/forms/Field";
import Button from "../../components/forms/Button";
import * as Yup from "yup";
import { SelectField } from "../../components/forms/SelectField";
import { abstract } from "../../components/image";
import { fitIn } from "../../services/api";
import { useGlobalContext } from "../../context/globalContext";
import LoaderComponent from "../../components/LoadingComponent";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  okr: Yup.string().required().label("Monthly OKR"),
  achievement: Yup.string().required().label("Current Achievement"),
  role: Yup.string().required().label("Current Role"),
  current_department: Yup.string().required().label("Current department"),
  new_role: Yup.string().required().label("Desired new role"),
  new_department: Yup.string().label("New department"),
});

const FitIn = () => {
  const navigate = useNavigate();
  const { user, token } = useGlobalContext();
  if (!token) {
    navigate("/sign-in");
  }

  // @ts-ignore
  const [loading, setLoading] = useState(false);
  // const email = user.email
  const email = user?.email;
  const vaultId = user?.id;

  const handleSubmit = async (values: any) => {
    setLoading(true);
    await fitIn(values);
    setLoading(false);
    toast.success("Form successfully submitted", {});
    navigate("/dashboard");
  };

  return (
    <div
      className="bg-white w-full bg-no-repeat object-cover bg-cover"
      style={{ backgroundImage: `url(${abstract})` }}
    >
      <Screen>
        <LoaderComponent loading={loading} />

        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Growth"}
          subsubtext={"I Don't Fit In"}
        />

        <div className="w-10/12 flex mx-auto mt-8  flex-col">
          <p className={` text-2xl text-black`}>I Don't Fit In</p>
          <p className={`text-lightDark text-xl `}>
            One Team,One Dream: Building the future of Healthcare
          </p>

          <div className="mt-8">
            <AppForm
              initialValues={{
                okr: "",
                email: email,
                achievement: "",
                role: "",
                current_department: "",
                new_role: "",
                user_id: vaultId,
              }}
              onSubmit={(values: any) => {
                handleSubmit(values);
              }}
              validationSchema={validationSchema}
            >
              <div className="mb-4 mt-8">
                <AppField
                  name={"okr"}
                  label={`Your Monthly OKR?`}
                  height={12}
                  as="textarea"
                />
              </div>

              <div className="mb-4 mt-8">
                <AppField
                  name={"achievement"}
                  label={`Current Achievement?`}
                  height={12}
                />
              </div>
              <div className="mt-2 mb-2">
                <AppField name={"role"} label={`Current Role?`} height={12} />
              </div>
              <div className="mb-2 mt-2">
                <SelectField
                  name={"current_department"}
                  label="Select your current department"
                  options={departmentOptions}
                />
              </div>
              <div className="mb-2 mt-2">
                <AppField name={"new_role"} label="Desired new role" />
              </div>
              <div className="mb-2 mt-2">
                <SelectField
                  name={"new_department"}
                  label="New department (if applicable)"
                  options={departmentOptions}
                />
              </div>

              <div className="flex mx-auto justify-center mt-8">
                <Button
                  width="60"
                  text={"SUBMIT"}
                  textColor="white"
                  bg={"lightRed"}
                />
              </div>
            </AppForm>
          </div>
        </div>
      </Screen>
    </div>
  );
};

export default FitIn;

const departmentOptions = [
  { value: 1, label: "People Operations" },
  { value: 2, label: "Engineering" },
  { value: 3, label: "Finance" },
  { value: 4, label: "Sales" },
  { value: 5, label: "Marketing" },
  { value: 6, label: "Communications" },
  { value: 7, label: "Customer Success" },
  { value: 8, label: "Other" },
];
